import { render, staticRenderFns } from "./CustomerDetailPage.vue?vue&type=template&id=c2b15036&scoped=true&"
import script from "./CustomerDetailPage.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetailPage.vue?vue&type=style&index=0&id=c2b15036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b15036",
  null
  
)

export default component.exports